export const sellLightTheme = {
  '--sell-left-container': '#EEEEEE',
  '--sell-left-descript-font': '#333333',
  '--sell-date': '#f8f8f8',
  '--ant-picker-cell-inner-new': '#333333',
}
export const sellDarkTheme = {
  '--sell-left-container': '#23262f',
  '--sell-left-descript-font': '#ffffff',
  '--sell-date': 'rgba(15, 23, 39, 0.39)',
  '--ant-picker-cell-inner-new': '#CCCCCC',
}
